import PlatformSearchRow from "../platform/PlatformSearchRow";

/** Marketing alias for platform search row (light surfaces only) */
export default PlatformSearchRow;
